var $42ae8ce6747a40c8$exports = {};
// document.addEventListener("DOMContentLoaded", function () {
function $42ae8ce6747a40c8$var$initializeSlider(selector, prevArrow, nextArrow, rtl = false) {
    const slider = $(selector);
    if (slider.length === 0) return; // Slider element not found, skip initialization
    const sliderOptions = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrow: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        rtl: rtl,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    arrow: true
                }
            }
        ]
    };
    slider.slick(sliderOptions);
}
const $42ae8ce6747a40c8$var$prevArrow = $(".movePrev");
const $42ae8ce6747a40c8$var$nextArrow = $(".moveNext");
const $42ae8ce6747a40c8$var$prevArrowMt = $(".movePrev-mt");
const $42ae8ce6747a40c8$var$nextArrowMt = $(".moveNext-mt");
document.addEventListener("DOMContentLoaded", function() {
    $42ae8ce6747a40c8$var$initializeSlider("body.ltr #directors-slider", $42ae8ce6747a40c8$var$prevArrow, $42ae8ce6747a40c8$var$nextArrow);
    $42ae8ce6747a40c8$var$initializeSlider("body.rtl #directors-slider", $42ae8ce6747a40c8$var$nextArrow, $42ae8ce6747a40c8$var$prevArrow, true);
    $42ae8ce6747a40c8$var$initializeSlider("body.ltr #management-slider", $42ae8ce6747a40c8$var$prevArrowMt, $42ae8ce6747a40c8$var$nextArrowMt);
    $42ae8ce6747a40c8$var$initializeSlider("body.rtl #management-slider", $42ae8ce6747a40c8$var$nextArrowMt, $42ae8ce6747a40c8$var$prevArrowMt, true);
});


//# sourceMappingURL=ar.dafd882f.js.map
